import React from 'react';
import { AddFunnelPropFromContext } from '../funnel-context';
import BaseAgreement from '../base-agreement';
import PRIVACY_POLICY_LINKS from './links';
import { FUNNELS, LABELS } from '../../util/constants';
const TITLES = {
  ARHI: LABELS.PRIVACY_POLICY_AGREEMENT_TITLE
};
const DESCRIPTIONS = {
  ARHI: LABELS.PRIVACY_POLICY_AGREEMENT_DESCRIPTION,
  APIA: [LABELS.PRIVACY_POLICY_AGREEMENT_DESCRIPTION_APIA, LABELS.PRIVACY_POLICY_AGREEMENT_DESCRIPTION],
  ING: [LABELS.PRIVACY_POLICY_AGREEMENT_DESCRIPTION_ING, LABELS.PRIVACY_POLICY_AGREEMENT_DESCRIPTION]
};
const FIELD_LABELS = {
  ARHI: LABELS.PRIVACY_POLICY_AGREEMENT_FIELD_LABEL
};
const FIELD_LABEL_AGREEMENT = {
  ARHI: LABELS.PRIVACY_POLICY_AGREEMENT_FIELD_LABEL_AGREEMENT,
  APIA: LABELS.PRIVACY_POLICY_AGREEMENT_FIELD_LABEL_AGREEMENT_APIA,
  ING: LABELS.PRIVACY_POLICY_AGREEMENT_FIELD_LABEL_AGREEMENT_ING,
  GU: LABELS.PRIVACY_POLICY_AGREEMENT_FIELD_LABEL_AGREEMENT_GU
};
const PrivacyPolicyAgreement = props => {
  const {
    id = 'privacyPolicyAgreement',
    name = 'privacyPolicyAgreement',
    links,
    funnel = FUNNELS.ARHI,
    values,
    title,
    description,
    fieldLabel,
    fieldLabelAgreement,
    required,
    ...otherProps
  } = props;
  const listOfLinks = links || PRIVACY_POLICY_LINKS[funnel] || PRIVACY_POLICY_LINKS.ARHI;
  return React.createElement(BaseAgreement, {
    id: id,
    name: name,
    funnel: funnel,
    values: values,
    title: title || TITLES[funnel] || TITLES.ARHI,
    description: description || DESCRIPTIONS[funnel] || DESCRIPTIONS.ARHI,
    links: listOfLinks,
    fieldLabel: fieldLabel || FIELD_LABELS[funnel] || FIELD_LABELS.ARHI,
    label: fieldLabelAgreement || FIELD_LABEL_AGREEMENT[funnel] || FIELD_LABEL_AGREEMENT.ARHI,
    ...otherProps
  });
};
PrivacyPolicyAgreement.defaultProps = {
  id: 'privacyPolicyAgreement',
  name: 'privacyPolicyAgreement'
};
const PrivacyPolicyAgreementWithFunnel = props => React.createElement(AddFunnelPropFromContext, null, React.createElement(PrivacyPolicyAgreement, {
  ...props
}));
export default PrivacyPolicyAgreementWithFunnel;